import React from 'react';
import { motion } from 'motion/react';
import { Button } from '@/components/ui/Button';

interface TabLoaderProps {
  message: string;
  icon: React.ReactNode;
  onCancel: () => void;
}

export const TabLoader = ({ message, icon, onCancel }: TabLoaderProps) => (
  <motion.div 
    initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.2 }}
    className="flex flex-col items-center justify-center h-[60vh] max-w-sm mx-auto text-center"
  >
    <div className="relative w-20 h-20 mb-8 flex items-center justify-center">
      <div className="absolute inset-0 border-t-2 border-emerald-500 rounded-full animate-spin"></div>
      <div className="absolute inset-2 border-r-2 border-emerald-400 rounded-full animate-spin direction-reverse" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
      <div className="absolute inset-4 border-b-2 border-sky-400 rounded-full animate-spin" style={{ animationDuration: '2s' }}></div>
      {icon}
    </div>
    <h3 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-2 truncate px-4">{message}</h3>
    <p className="text-sm text-slate-700 dark:text-slate-400 mb-6">The system is processing your request. Please wait...</p>
    <Button variant="outline" onClick={onCancel}>
      Cancel Request
    </Button>
  </motion.div>
);
